'use strict';
class Program {
    constructor(program, device) {
        this.reference = program.rf;
        this.time_start = program.hi;
        this.time_stop = program.hf;
        this.temperature = program.tc;
        this.temperature_min = device.tmm;
        this.temperature_max = device.tmx;
        this.mode = program.m;
        this.status = program.e;
        this.floor = program.sv;
        //this.fan = program.vv;
        this.allowFloor = () => program.s;
        //this.allowFan = () => program.v;
        this.days = [];
        for (let index = 1; index <= 8; index++) {
            if (program[`d${index}`] == 1) this.days.push(`${index}`);
        }
    }

    //#region is
    isEnable() {
        return this.status != '0';
    }

    isActive() {
        if (!this.isEnable()) return false;
        let now = new Date();
        let nowDay = ((now.getDay() + 6) % 7) + 1;
        if (!this.days.includes(`${nowDay}`)) return false;
        let dateStart = new Date().setHours(this.time_start.split(':')[0], this.time_start.split(':')[1]);
        let dateStop = new Date().setHours(this.time_stop.split(':')[0], this.time_stop.split(':')[1]);
        if (!(dateStart < now && dateStop > now)) return false;
        return true;
    }

    // hasFanMode() {
    //     return this.fan == '1';
    // }

    isModeValid() {
        return ['0', '1', '2', '3', '4', '5'].includes(this.mode);
    }

    isModeHeat() {
        return ['0', '2', '4'].includes(this.mode);
    }

    isModeAC() {
        return ['0', '1', '4', '5'].includes(this.mode);
    }

    isModeFloor() {
        return ['2', '3', '4', '5'].includes(this.mode);
    }

    isOn() {
        return this.status != '0';
    }
    //#endregion

    togglePower(status) {
        this.status = status ? '1' : '0';
    }

    updateOrder(order) {
        this.temperature = order;
    }

    setCool() {
        if (!this.isModeValid()) return (this.mode = '1');
        if (!this.isModeHeat()) return;
        let mode = Number(this.mode);
        mode += 1;
        this.mode = `${mode}`;
    }

    setHot() {
        if (!this.isModeValid()) return (this.mode = '0');
        if (this.isModeHeat()) return;
        let mode = Number(this.mode);
        mode -= 1;
        this.mode = `${mode}`;
    }

    toggleAC() {
        this.setModeHeat(!this.isModeAC(), this.isModeFloor());
    }

    toggleRadiatingFloor() {
        this.setModeHeat(this.isModeAC(), !this.isModeFloor());
    }

    // toggleFan() {
    //     this.fan = this.hasFanMode() ? '0' : '1';
    // }

    setModeHeat(ac, floor) {
        if (!ac && !floor) return;

        let mode = null;
        if (ac && !floor) mode = 0;
        if (!ac && floor) mode = 2;
        if (ac && floor) mode = 4;

        if (!this.isModeHeat()) mode += 1;

        this.mode = `${mode}`;
    }
}

export default Program;
